import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import authReducer from './auth/authSlice'
import usersReducer from './users/usersSlice'
import operationsReducer from './operations/operationsSlice'
import expensesReducer from './expenses/expensesSlice'
import withdrawsReducer from './withdraws/withdrawsSlice'
import patientsReducer from './patients/patientsSlice'
import appointmentsReducer from './appointments/appointmentSlice'

import popupReducer from './popups/popupSlice'
// Create the Redux store
export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    popups: popupReducer,
    operations: operationsReducer,
    appointments: appointmentsReducer,
    patients: patientsReducer,
    expenses: expensesReducer,
    withdraws: withdrawsReducer
  },
  middleware: (getDefaultMiddleware) => {
    const baseMiddleware = getDefaultMiddleware({
      serializableCheck: {
        warnAfter: 128,
        // Ignore specific paths related to Firebase auth objects
        ignoredPaths: ['auth.user', 'auth.user.stsTokenManager', 'auth.user.proactiveRefresh'],
        ignoredActionPaths: [
          'meta.arg',
          'payload.user',
          'payload.auth',
          'payload.metadata',
          'payload.user.stsTokenManager',
          'payload.stsTokenManager',
          'payload.user.proactiveRefresh',
          'payload.proactiveRefresh'
        ]
      }
    })

    if (process.env.NODE_ENV === 'development') {
      return baseMiddleware.concat(logger)
    }

    return baseMiddleware
  }
})
